import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';
import { getLastUnfinishedRouteMutationKey } from '.';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';

type UseSearchLastUnfinishedRouteResponse = ServiceResponse<Function, Route | null>;

export const useSearchLastUnfinishedRoute = (): UseSearchLastUnfinishedRouteResponse => {
  const { data, isError, isLoading, refetch, isSuccess } = useQuery<Route | null>(
    getLastUnfinishedRouteMutationKey(),
    () => routeService.searchLastUnfinishedRoute()
  );

  return { error: isError, isLoading, run: refetch, success: isSuccess, data };
};
